// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebarParentoptions {
  background-color: white !important;
  border-radius: 25px !important;
  margin-left: 10%;
  height: -moz-fit-content;
  height: fit-content;
  margin-top: 5%;
}
.sidebarParentoptionsdarkTheme {
  background-color: #585858 !important;
  color: whitesmoke;
}

.sidebarParentoptions1 {
  margin-inline-start: 15px;
  margin-block-start: 10px;
  padding-bottom: 3%;
  margin-inline-end: 30px;
}
.EditProfile {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 20px;
  overflow: auto;
  scrollbar-width: none;
}
@media screen and (min-width: 768px) {
  .EditProfile {
    overflow: hidden;
  }
}

@media screen and (min-width: 992px) {
  .EditProfile {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
  }
}
.sidebartoggleoptions {
  margin-right: 5%;
  margin-left: 10%;
  margin-block-start: 70px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/EditProfile/EditProfile.css"],"names":[],"mappings":"AAAA;EACE,kCAAkC;EAClC,8BAA8B;EAC9B,gBAAgB;EAChB,wBAAmB;EAAnB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;EACzB;AACF;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;AAC1B","sourcesContent":[".sidebarParentoptions {\r\n  background-color: white !important;\r\n  border-radius: 25px !important;\r\n  margin-left: 10%;\r\n  height: fit-content;\r\n  margin-top: 5%;\r\n}\r\n.sidebarParentoptionsdarkTheme {\r\n  background-color: #585858 !important;\r\n  color: whitesmoke;\r\n}\r\n\r\n.sidebarParentoptions1 {\r\n  margin-inline-start: 15px;\r\n  margin-block-start: 10px;\r\n  padding-bottom: 3%;\r\n  margin-inline-end: 30px;\r\n}\r\n.EditProfile {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n  margin-bottom: 20px;\r\n  overflow: auto;\r\n  scrollbar-width: none;\r\n}\r\n@media screen and (min-width: 768px) {\r\n  .EditProfile {\r\n    overflow: hidden;\r\n  }\r\n}\r\n\r\n@media screen and (min-width: 992px) {\r\n  .EditProfile {\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: center;\r\n    align-items: flex-start;\r\n  }\r\n}\r\n.sidebartoggleoptions {\r\n  margin-right: 5%;\r\n  margin-left: 10%;\r\n  margin-block-start: 70px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
